// directiva v-click-outside.js
export default {
    bind(el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        // Verifica si el clic ocurrió fuera del elemento
        if (!(el == event.target || el.contains(event.target))) {
          // Si ocurrió fuera, ejecuta la función proporcionada
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  };
  